import Vue from "vue";
import Router from "vue-router";
import Article from "@/components/article";
import Home from "@/components/home";
import Articles from "@/components/articles";
import Author from "@/components/author";
import Authors from "@/components/authors";
import SignUp from "@/components/signup";
import SignIn from "@/components/signin";
import Equipe from "@/components/equipe";
import Evenements from "@/components/evenements";
import Evenement from "@/components/evenement";
import Contact from "@/components/contact";
import ResetPassword from "@/components/reset-password";
import Logout from "@/components/logout";
import Conseiller from "@/components/conseiller";
import ConseillerDetails from "@/components/conseiller/conseiller-details/conseiller-details";

Vue.use(Router);

export const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/articles",
    leftNavTitle: "Transmettre",
    name: "articles",
    component: Articles
  },
  {
    path: "/evenements",
    leftNavTitle: "Se rencontrer",
    name: "evenements",
    component: Evenements
  },
  {
    path: "/evenements/past",
    name: "evenements-passés",
    component: Evenements
  },
  {
    path: "/evenements/:eventSlug",
    name: "evenement",
    component: Evenement
  },
  {
    path: "/article/:slug",
    name: "article",
    component: Article
  },
  {
    path: "/author/:slug",
    name: "author",
    component: Author
  },
  {
    path: "/conseiller",
    leftNavTitle: "Conseiller",
    name: "conseiller",
    component: Conseiller
  },
  {
    path: "/conseiller/:page",
    name: "conseiller",
    component: ConseillerDetails
  },

  {
    path: "/intervenants",
    rightNavTitle: "Intervenants",
    name: "intervenants",
    component: Authors
  },
  {
    path: "/intervenants/:authorId",
    name: "intervenants",
    component: Authors
  },
  {
    path: "/equipe",
    rightNavTitle: "Qui sommes nous ?",
    name: "equipe",
    component: Equipe
  },
  {
    path: "/contact",
    name: "contact",
    component: Contact
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword
  },
  {
    path: "/deconnection",
    name: "logout",
    component: Logout
  },
  {
    path: "/set-password/:token",
    name: "setpassword",
    component: SignUp
  }
];

export default new Router({
  mode: "history",
  routes
});
